import useReadyForExport from "./hooks/useReadyForExport";
import ProgressExport from "./components/ProgressExport";
import useFooterStore from "views/hooks/useFooterStore";
import ExportedTable from "./components/ExportedTable";
import useExportApi from "./hooks/useExportApi";
import { useTranslation } from "react-i18next";
import { FaFileExport } from "react-icons/fa";
import CardTitle from "components/CardTitle";
import Loading from "components/Loading";
import { Card, Col, Row } from "antd";
import FACT from "./components/FACT";
import { useEffect, useRef } from "react";

export default function TransferToAccounts(): React.ReactElement {
  const { t } = useTranslation();

  const saveLoading = useFooterStore(state => state.saveLoading);

  const refetchExportedTable = useRef<(() => void) | undefined>(undefined);
  const { handleExportPlatform, bookEntriesType, loading } = useExportApi(() =>
    refetchExportedTable.current?.(),
  );
  const { readyForExportNeofact, refetchFact, totalDocumentsReadyFact, isLoadingReadyFACT } =
    useReadyForExport();

  useEffect(() => {
    readyForExportNeofact();
  }, []);

  return (
    <>
      {saveLoading ? (
        <Loading />
      ) : (
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card
              className="antd-newrai-card"
              title={<CardTitle icon={<FaFileExport />} title={t("Export")} />}
            >
              <Col>
                <FACT
                  totalDocumentsReadyFact={totalDocumentsReadyFact}
                  refetchFact={refetchFact}
                  isLoadingReadyFACT={isLoadingReadyFACT}
                  onExport={() => handleExportPlatform("nf")}
                  isExporting={bookEntriesType === "nf" && loading}
                />
              </Col>
              <Col>{bookEntriesType && <ProgressExport bookEntriesType={bookEntriesType} />}</Col>
            </Card>
          </Col>
          <Col span={24}>
            <Card
              className="antd-newrai-card"
              title={<CardTitle icon={<FaFileExport />} title={t("Exports history")} />}
            >
              <ExportedTable refetchRef={refetchExportedTable} />
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
}
